<script setup lang="ts">
import { DropdownMenuLabel } from 'reka-ui';
</script>

<template>
    <DropdownMenuLabel class="px-3 py-1.5 text-xs font-semibold text-muval-gray-3">
        <slot />
    </DropdownMenuLabel>
</template>
